import createSmartIntersector from "../../utils/createSmartIntersector";
import * as mediaPool from "./_mediaPool";
import { controlSpacer } from "./utils";

const instagramClass = "instagram-media";
const lazyInstagramClass = "lazy-instagram-media";

function onIntersect(entry) {
    async function onFreeSlot(resourceID) {
        const target = entry.target;

        function releaseIGResource(frame) {
            const container = target.closest(".rm-embed-container.rm-loading");

            if (container) {
                container.classList.remove("rm-loading");
                container.classList.add("rm-loaded");
                setTimeout(() => {
                    controlSpacer(frame, container);
                }, 500);
            }

            mediaPool.release(resourceID);
        }

        target.classList.add(instagramClass);
        target.classList.remove(lazyInstagramClass);

        try {
            const { renderInstagramEmbed } = await import("./instagramThreadsEmbedRenderer");

            if (!renderInstagramEmbed(target, releaseIGResource)) {
                mediaPool.release(resourceID);
            }
        } catch (error) {
            mediaPool.release(resourceID);
        }
    }
    mediaPool.request(1700).then(onFreeSlot, () => {});
}

function invalidate(element) {
    element.classList.remove(instagramClass);
    element.classList.add(lazyInstagramClass);
}

export default function loadLazyInstagram(intersectionObserverProvider) {
    createSmartIntersector(intersectionObserverProvider, {
        onIntersect,
        onAppear: invalidate,
        initialThreshold: 300,
        selector: "blockquote.instagram-media,blockquote.lazy-instagram-media",
    });
}
